<template>
    <div class="mt-1">
        <h4 class="headline text-xs-center">Item UoM Overrides</h4>
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>
        <v-card>
            <v-card-text>
                <v-layout row py-1 align-center>
                    <v-flex xs4>
                        <v-text-field
                            v-model="searchTerm"
                            label="Search (Material#, Catalog#, Description)"
                            hint="Press Enter or click Search"
                            @keyup.enter="onSearch"
                            clearable
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pl-2>
                        <v-btn color="secondary" @click="onSearch">Search</v-btn>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs3 text-xs-right>
                        <span class="body-1" v-if="totalCount > 0">Total: {{ totalCount }} items</span>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    :total-items="totalCount"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[25, 50, 100]"
                    class="elevation-1"
                >
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.materialNumber }}</td>
                        <td>{{ props.item.catalogNumber }}</td>
                        <td>{{ props.item.description }}</td>
                        <td>
                            <span v-if="editingId !== props.item.id">
                                {{ props.item.webQuoteUom }}
                            </span>
                            <v-text-field
                                v-else
                                v-model="editForm.webQuoteUom"
                                single-line
                                hide-details
                                dense
                            ></v-text-field>
                        </td>
                        <td>
                            <span v-if="editingId !== props.item.id">
                                {{ props.item.comment }}
                            </span>
                            <v-text-field
                                v-else
                                v-model="editForm.comment"
                                single-line
                                hide-details
                                dense
                            ></v-text-field>
                        </td>
                        <td class="text-xs-right" style="white-space: nowrap;">
                            <template v-if="editingId !== props.item.id">
                                <v-btn small flat color="primary" @click="onEdit(props.item)">Edit</v-btn>
                            </template>
                            <template v-else>
                                <v-btn small flat color="green" @click="onSave">Save</v-btn>
                                <v-btn small flat @click="onCancelEdit">Cancel</v-btn>
                            </template>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-snackbar v-model="snackbar" :timeout="3000" top color="success">
            {{ snackbarText }}
            <v-btn flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data: () => ({
        searchTerm: '',
        items: [],
        totalCount: 0,
        pagination: {
            page: 1,
            rowsPerPage: 50,
            sortBy: 'materialNumber',
            descending: false,
        },
        headers: [
            { text: 'Material #', align: 'left', value: 'materialNumber', sortable: false },
            { text: 'Catalog #', align: 'left', value: 'catalogNumber', sortable: false },
            { text: 'Description', align: 'left', value: 'description', sortable: false },
            { text: 'WebQuote UoM', align: 'left', value: 'webQuoteUom', sortable: false },
            { text: 'Comment', align: 'left', value: 'comment', sortable: false },
            { text: '', align: 'right', sortable: false },
        ],
        editingId: null,
        editForm: {
            webQuoteUom: '',
            comment: '',
        },
        snackbar: false,
        snackbarText: '',
    }),
    computed: {
        error() {
            return this.$store.getters.error
        },
        loading() {
            return this.$store.getters.loading
        },
    },
    watch: {
        pagination: {
            handler() {
                this.loadData()
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions('adminItemUomOverride', [
            'getUomOverrideList',
            'saveUomOverride',
            'syncUomOverrides',
        ]),
        onSearch() {
            this.pagination.page = 1
            this.loadData()
        },
        async loadData() {
            const payload = {
                search: this.searchTerm || '',
                page: this.pagination.page,
                pageSize: this.pagination.rowsPerPage,
            }
            const result = await this.getUomOverrideList(payload)
            if (result && result.items) {
                this.items = result.items
                this.totalCount = result.totalCount
            }
        },
        onEdit(item) {
            this.editingId = item.id
            this.editForm.webQuoteUom = item.webQuoteUom || ''
            this.editForm.comment = item.comment || ''
        },
        onCancelEdit() {
            this.editingId = null
            this.editForm.webQuoteUom = ''
            this.editForm.comment = ''
        },
        async onSave() {
            const payload = {
                id: this.editingId,
                webQuoteUom: this.editForm.webQuoteUom,
                comment: this.editForm.comment,
            }
            const result = await this.saveUomOverride(payload)
            if (result === 'Success') {
                this.snackbarText = 'UoM override saved successfully.'
                this.snackbar = true
                this.editingId = null
                this.loadData()
            } else {
                alert('Save failed: ' + result)
            }
        },
        onDismissed() {
        },
    },
    created: async function () {
        // Sync new items from itmItem table
        await this.syncUomOverrides()
        this.loadData()
    },
}
</script>
